function payoutFeeLineLabel (feeKey, baseLabel, feeLabel) {
  if (feeKey !== 'smarttransytFee' || !feeLabel) {
    return baseLabel
  }
  return baseLabel + ' (' + feeLabel + ')'
}

function summaryKeepsFeeRate (payoutFeeLabels) {
  const labels = payoutFeeLabels || []
  return !labels.some(function (item) {
    return item && item.key === 'smarttransytFee'
  })
}

function summaryFeesValue (feeDeductionLabel, feeLabel, showSummaryFeeRate) {
  if (showSummaryFeeRate) {
    return feeDeductionLabel + ' (' + feeLabel + ')'
  }
  return feeDeductionLabel
}

module.exports = {
  payoutFeeLineLabel,
  summaryKeepsFeeRate,
  summaryFeesValue
}
